import qs from 'query-string'

type Param = string | number | undefined
const fixParamType = (param: Param) => {
  return String(param)
}
const isNonEmpty = (v: unknown): boolean => {
  return typeof v !== 'undefined'
}

const stringifyQueryParams = (record: Record<string, Param | Param[]>): Record<string, string | string[]> => {
  const result: Record<string, string | string[]> = {}
  for (const [key, val] of Object.entries(record)) {
    if (Array.isArray(val)) {
      result[key] = val.filter(isNonEmpty).map(fixParamType)
    } else {
      if (isNonEmpty(val)) {
        result[key] = fixParamType(val)
      }
    }
  }
  return result
}

const stringifyUrl = (options: { url: string; query?: Record<string, Param | Param[]> }): string => {
  return qs.stringifyUrl({ url: options.url, query: options.query ? stringifyQueryParams(options.query) : {} })
}

export const helpersUrl = {
  stringifyQueryParams,
  stringifyUrl,
}
